import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ContentChild,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { NgpDialog, NgpDialogOverlay } from 'ng-primitives/dialog';

import {
  SuiDialogHeaderSlot,
  SuiDialogContentSlot,
  SuiDialogFooterSlot,
} from './sui-dialog-simple-slots';

import { DialogLayoutBase } from '../dialog-layout-base';

@Component({
  selector: 'sui-dialog-simple',
  standalone: true,
  imports: [NgTemplateOutlet, NgpDialog, NgpDialogOverlay],
  templateUrl: './sui-dialog-simple.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./sui-dialog-simple.component.scss'],
})
export class SuiDialogSimpleComponent extends DialogLayoutBase {
  @ContentChild(SuiDialogHeaderSlot, {
    read: TemplateRef,
    descendants: true,
  })
  headerTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogContentSlot, {
    read: TemplateRef,
    descendants: true,
  })
  contentTpl?: TemplateRef<any>;

  @ContentChild(SuiDialogFooterSlot, {
    read: TemplateRef,
    descendants: true,
  })
  footerTpl?: TemplateRef<any>;

  // * Size class uses component-specific prefix
  protected get sizeClass(): string {
    if (!this.config.size) return '';
    return `sui-dialog-simple--${this.config.size}`;
  }
}
